import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'



class Hero extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            height: 0,
            width: 0
        }
    }

    updateDimensions = () => {
        if (this.state.height !== window.innerHeight) {
            this.setState({height: window.innerHeight})
        }
        if (this.state.width !== window.innerWidth) {
            this.setState({width: window.innerWidth})
        }
    }

    
    componentDidMount() {
        this.setState({height: window.innerHeight, width: window.innerWidth})
        window.addEventListener('resize', this.updateDimensions)
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions)
    }

    render() {

        const Section = styled.section`
            position: relative;
            margin-top: 100px;            
        `        

        const Heading2 = styled.h2`
            font-size: 40px;
            line-height: 50px;
            color: #fff;
            font-weight: 700;
            text-transform: uppercase;
            background: -webkit-linear-gradient(left, #00ecff, #7133ff);
            background: -o-linear-gradient(right, #00ecff, #7133ff);
            background: -moz-linear-gradient(right, #00ecff, #7133ff);
            background: linear-gradient(to right, #00ecff, #7133ff); 
           -webkit-background-clip: text;
           -webkit-text-fill-color: transparent;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 60px;
                line-height: 70px;
            }
        `

        const Heading2b = styled.h2`
            font-size: 40px;
            color: #00ecff;
            font-weight: 700;
            text-transform: uppercase;
            @media (max-width:767px) {
                font-size: 30px;
                line-height: 40px;
            }
           @media (min-width:768px) and (max-width:1500px) {
                font-size: 60px;
                line-height: 70px;
            }
        `

        const Separator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #00ecff;
            margin-bottom: 30px;
            @media (min-width:768px) {
                margin-left: 6px;
            }
            @media (max-width:767px) {
                margin-left: 2px;
            }
        `

        const BottomContent = styled.div`
            position: relative;
            width: 100%;
            padding-bottom: 100px;            
            @media (min-width:1025px) and (max-width: 1400px) {    
                bottom: -35%;
            }
            @media (max-width:767px) {
                position: relative;
                bottom: 0;
            } 
            @media (min-width:768px) and (max-width: 1023px) {    
                bottom: -25%;
            }
        `

        const ServiceCol = styled(Col)`
            padding: 0;
            border-right: #444;
            &.no-border {
                border-right: none;
            }
            @media (max-width:500px) {
                border-right:none;
            }
        `

        const Service = styled.div`
            min-height: 300px;
            background-color: #111;
            transition: .2s;
            display: flex;
            justify-content: center;
            flex-direction: column;
            &:hover {
                background-color: #222;
            }
        `
        const ServiceContent = styled.div`
            padding: 40px;
            color: #fff;
        `
        const ServiceHeading = styled.h3`
            font-size: 25px;
            font-weight: 400;
            font-family: Antonio,sans-serif;
        `
        
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #4285f4;
            margin-bottom: 10px;
        `

        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 14px;
            font-weight: 300;
            color: #c5c5c5;
        `        

        const Content = styled.div`
            position: relative;
            z-index: 10
        `

        const Text = styled.p`
            font-size: 20px;
            font-weight: 300;
            color: #c5c5c5;
            padding-bottom: 30px;
        `

        const AboutContainer = styled(Container)`
            padding: 50px 0;
            @media (max-width: 500px) {
                padding: 50px 20px;
            }
        `

        const Heading2c = styled.h2`
            font-size: 60px;
            font-family: Poppins;
            color: #fff;
            line-height: 70px;
            text-align: center;
            padding-bottom: 80px;
            @media (max-width: 767px) {
                font-size: 40px;            
                line-height: 50px;
            }        
        `
        
        const Color1 = styled.span`
            color: #4081ec;            
        `

        const Color2 = styled.span`
            color: #e34133;            
        `

        const Color3 = styled.span`
            color: #f3b605 ;            
        `

        const Color4 = styled.span`
            color: #32a350;            
        `
        
        return (
            <Section>
                <Container>
                    <Content>
                        <Heading2>
                            Posicionamiento SEO
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image1} alt="SEO en Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Análisis y auditoría SEO integral
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Comenzamos cada proyecto con un análisis exhaustivo de tu presencia en línea. Identificamos áreas
                                            de mejora y diseñamos una estrategia sólida para optimizar tu sitio web.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image2} alt="Palabras clave" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Investigación de palabras clave
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Las palabras clave son fundamentales. Realizamos una investigación detallada para identificar
                                            las más relevantes para tu negocio y audiencia.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <Container>
                    <Content>

                        <Heading2>
                            Optimización para motores de búsqueda
                        </Heading2>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image3} alt="Optimización On-Page y Off-Page" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Optimización On-Page y Off-Page
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Desde la optimización de contenido hasta la construcción de enlaces de calidad, implementamos tácticas
                                            on-page y off-page para mejorar tu clasificación en los motores de búsqueda.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image4} alt="Creación de contenido persuasivo" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Creación de contenido persuasivo
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            El contenido es esencial. Creamos contenido relevante y persuasivo que no solo atrae a los motores de
                                            búsqueda, sino que también cautiva a tu audiencia.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>

                <AboutContainer>
                    <Row>
                        <Col md={12}>
                            
                                <Heading2c>Sin compromisos de permanencia</Heading2c>
                                <Text>
                                    En VASCO Solutions, creemos en la transparencia y la libertad. Por eso, te ofrecemos servicios SEO sin compromisos
                                    de permanencia ni contratos engorrosos. Pagas solo por el servicio contratado y cancelas cuando quieras.</Text>
                            
                        </Col>
                    </Row>
                </AboutContainer>

                <Container>
                    <Content>

                        <Heading2b>
                            Posicionamiento en <Color1>G</Color1><Color2>o</Color2><Color3>o</Color3><Color1>g</Color1><Color4>l</Color4><Color2>e</Color2>
                        </Heading2b>
                        <Separator />
                    </Content>
                </Container>

                <BottomContent>
                    <Container>
                        <Row>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image5} alt="Google" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Google: El objetivo primordial
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Google es el gigante de los motores de búsqueda, y alcanzar las primeras posiciones en sus resultados es
                                            clave. Descubre las tácticas esenciales para conquistar el codiciado top 3.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image6} alt="Posicionamiento web en buscadores" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Más que palabras clave
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            La optimización no se limita a saturar tu contenido con palabras clave. Exploraremos las prácticas actuales,
                                            desde la estructura del sitio hasta la velocidad de carga, que marcan la diferencia.
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6} style={{ borderRight: this.state.width > 500 ? "1px solid #444" : "none" }}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image7} alt="SEO en Pereira" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            Navegando por el futuro
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            El mundo del SEO evoluciona rápidamente. Desde la búsqueda por voz hasta las actualizaciones de algoritmos en los motores de búsqueda.
                                            En VASCO Solutions usamos técnicas White hat (Sombrero blanco).
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                            <ServiceCol md={6}>
                                <Service>
                                    <ServiceContent>
                                        <ServiceIcon>
                                            <GatsbyImage image={this.props.image8} alt="SEO en Colombia" />
                                        </ServiceIcon>
                                        <ServiceHeading>
                                            ¿Listo para Impulsar tu Presencia en Línea?
                                        </ServiceHeading>
                                        <ServiceSeparator />
                                        <ServiceText>
                                            Permítenos ser tu aliado en la conquista del mundo digital. Transformemos juntos tu presencia en línea y llevemos
                                            tu negocio a nuevas alturas. ¡Contáctanos hoy para una consulta personalizada!
                                        </ServiceText>
                                    </ServiceContent>
                                </Service>
                            </ServiceCol>
                        </Row>
                    </Container>
                </BottomContent>
            </Section>            
        )
    }
}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/seo.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/filter.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/placard.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image4: file(relativePath: { eq: "icons/paper.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image5: file(relativePath: { eq: "icons/google.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image6: file(relativePath: { eq: "icons/web.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image7: file(relativePath: { eq: "icons/whitehat.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image8: file(relativePath: { eq: "icons/litespeed.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
        }
      `}
        render={(data) => {            
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            const image4 = getImage(data.image4.childImageSharp.gatsbyImageData);
            const image5 = getImage(data.image5.childImageSharp.gatsbyImageData);
            const image6 = getImage(data.image6.childImageSharp.gatsbyImageData);
            const image7 = getImage(data.image7.childImageSharp.gatsbyImageData);
            const image8 = getImage(data.image8.childImageSharp.gatsbyImageData);
            return <Hero data={data} image1={image1} image2={image2} image3={image3} image4={image4} image5={image5} image6={image6} image7={image7} image8={image8}{...props} />;
        }}
    />
);

export default Iconos;
